module.exports = __webpack_public_path__ + "static/media/icon_back_arrow_filled.72385b6f.svg";